import { createClient } from 'next-sanity';
import { env } from '../../lib/env';

const EXCLUDED_FIELDS = [
  'colorTheme',
  'topPadding',
  'bottomPadding',
  'headingConfig',
  'titleConfig',
  'aspectRatio',
  'aspectRatioMobile',
  'aspectRatioDesktop',
  'mobileAspectRatio',
  'desktopAspectRatio',
  'buttonVariant',
  'backgroundColor',
  'textColor',
  'borderColor',
  'backgroundPosition',
  'fontFamily',
  'fontSize',
  'config',
  'settings',
  'bgColor',
  'textColor',
];

export const client = createClient({
  projectId: env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: 'v2025-06-25',
  useCdn: true,
  perspective: 'published',
  stega: {
    // Can't use baseEnvs.VERCEL_ENV because it's a server env
    enabled: process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview',
    studioUrl: '/studio',
    filter: (props) => {
      const base = props.sourcePath.at(0);
      const key = props.sourcePath.at(-1);
      const oneLevelUp = props.sourcePath.at(-2);

      if (
        (key && typeof key === 'string' && EXCLUDED_FIELDS.includes(key)) ||
        (base && typeof base === 'string' && EXCLUDED_FIELDS.includes(base)) ||
        (oneLevelUp &&
          typeof oneLevelUp === 'string' &&
          EXCLUDED_FIELDS.includes(oneLevelUp))
      ) {
        return false;
      }

      if (props.sourcePath.at(-1) === 'title') {
        return true;
      }

      return props.filterDefault(props);
    },
  },
});
